export default "__VITE_ASSET__DxjUv96$__"